import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem, TranslationFormItem } from 'utils/form_helpers';
import CountrySelect from "../CountrySelect";


class CityForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { actions, geo_city } = this.props;
                const instance = geo_city.editObject;

                let data = Object.assign({}, values);
                if (instance && instance.id) {
                    data.id = instance.id;
                }
                actions.geoCityUpdate({ data });
            }
        });
    };

    close = () => {
        const { actions } = this.props;
        actions.geoCityShowEditForm({ show: false });
    };

    render() {
        const { form, geo_city, country_id } = this.props;
        const { showEditForm, updateStatus, editObject } = geo_city;
        const instance = editObject;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        const isLoading = geo_city.updateStatus.isLoading;

        return (
            <Modal
                visible={showEditForm}
                title="Редактирование города"
                onCancel={this.close}
                maskClosable={false}
                destroyOnClose={true}
                footer={[
                    <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
                        Сохранить
                    </Button>,
                ]}
            >
                <Spin spinning={isLoading}>
                    <Form onSubmit={this.handleSubmit}>
                        {errorData.non_field_errors &&
                        <div className="form-error">{errorData.non_field_errors}</div>}

                        <CountrySelect
                            form={form}
                            instance={instance}
                            name="country"
                            label="Страна"
                            required={true}
                            errorData={errorData}
                            initialValue={country_id}
                        />

                        <TranslationFormItem
                            form={form}
                            instance={instance}
                            name="name"
                            label="Название"
                            required={true}
                            errorData={errorData}
                        />

                        <FormItem
                            form={form}
                            instance={instance}
                            name="code"
                            label="Код"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>

                        <FormItem
                            form={form}
                            instance={instance}
                            name="slug"
                            label="Путь"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}


const WrappedCityForm = Form.create()(CityForm);

function mapStateToProps(state) {
    return {
        auth: state.auth,
        geo_city: state.geo_city,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.geo_city), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedCityForm);

